import { supabase } from '../lib/supabase';

export function storageGet(k){return supabase.from('app_storage').select('value').eq('key',k).maybeSingle().then(function(r){return (r&&r.data)?JSON.parse(r.data.value):null;});}

export function saveDraft(k,v){try{localStorage.setItem("draft_"+k,JSON.stringify(v));}catch(e){}}
export function loadDraft(k){try{var d=localStorage.getItem("draft_"+k);return d?JSON.parse(d):null;}catch(e){return null;}}
export function clearDraft(k){try{localStorage.removeItem("draft_"+k);}catch(e){}}

export function callClaude(sys,usr,maxTokens){
  maxTokens=maxTokens||1600;
  return fetch('/api/claude',{method:'POST',headers:{'Content-Type':'application/json'},
    body:JSON.stringify({system:sys,user:usr,max_tokens:maxTokens})
  }).then(function(r){return r.json();}).then(function(d){return d.text||'';});
}

export function fileToBase64(f){return new Promise(function(res,rej){var r=new FileReader();r.onload=function(){res(r.result);};r.onerror=rej;r.readAsDataURL(f);});}
export function readFileAsText(f){return new Promise(function(res,rej){var r=new FileReader();r.onload=function(){res(r.result);};r.onerror=rej;r.readAsText(f);});}
export function dateStr(){return new Date().toLocaleDateString();}
